import { translate } from "app/filters/i18nFilter";
import styled from "styled-components";
import { CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import type { FC } from "react";

const NotAvailable = styled(CenteredFlexRow)`
    width: 100%;
    ${setFontVariant("h3", colorsPalettes.carbon[500])};
    align-items: end;
`;
const NotAvailableText = styled(CenteredFlexRow)`
    ${setFontVariant("subTitle3Alt", colorsPalettes.carbon[500])};
    width: 100%;
    padding: 0 16px;
    text-align: center;
`;
interface INoDataDemandSize {
    noDataTitleKey: string;
    noDataSubTitleKey: string;
}

const NoDataDemandSize: FC<INoDataDemandSize> = ({ noDataTitleKey, noDataSubTitleKey }) => {
    return (
        <>
            <NotAvailable>{translate(noDataTitleKey)}</NotAvailable>
            <NotAvailableText
                dangerouslySetInnerHTML={{
                    __html: translate(noDataSubTitleKey),
                }}
            ></NotAvailableText>
        </>
    );
};
export default NoDataDemandSize;
